import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import { motion } from "framer-motion";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import Divider from "../../../../core/components/Divider.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import { cadastraFotoUsuario, deleteFotoUser } from "../../../../services/ModuloGerenciador/Midia.js";
import { autoEditaUser } from "../../../../services/ModuloGerenciador/Usuario.js";
import "./AutoEditar.css";

import DeleteIcon from "@mui/icons-material/Delete";

interface UpdateProfileDto {
	UsuarioId: number;
	nome: string;
	nascimento: Date;
	telefone: string;
	email: string;
	cargo: string;
}

function AutoEditar() {
	const { profile, handleLoadData } = useProfile();

	const [values, setValues] = useState<UpdateProfileDto>({
		UsuarioId: 0,
		nome: "",
		nascimento: new Date(),
		telefone: "",
		email: "",
		cargo: "",
	});
	const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);
	const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined);
	const [openToastErro, setOpenToastErro] = useState(false);
	const [textoErro, setTextoErro] = useState("");
	const [openToastSucesso, setOpenToastSucesso] = useState(false);
	const [textoSucesso, setTextoSucesso] = useState("");
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const handleImageChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const file = e.target.files?.[0];
			setSelectedFile(file);
			const reader = new FileReader();

			reader.onloadend = () => {
				setImageSrc(reader.result as string);
			};

			if (file) {
				reader.readAsDataURL(file);
			}
		},
		[]
	);

	const handleCloseToastErro = () => {
		setOpenToastErro(false);
	};


	const handleCloseToastSucesso = () => {
		setOpenToastSucesso(false);
	};

	const autoEditaUsuario = useCallback(async () => {
		if (!profile || !profile.usuario) return;

		setLoading(true);
		await autoEditaUser(profile?.usuario.idUsuario, values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					handleLoadData();
					setLoading(false);
					navigate("/");
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	}, [values, profile?.usuario.idUsuario, profile?.token, navigate]);

	const salvarFoto = useCallback(async () => {
		if (!selectedFile) {
			setTextoErro("Nenhum arquivo selecionado.");
			setOpenToastErro(true);
			return;
		}

		setLoading(true);
		const formData = new FormData();
		formData.append("file", selectedFile);
		await cadastraFotoUsuario(
			profile?.usuario.idUsuario,
			formData,
			profile?.token
		)
			.then((result) => {
				if (result.status === 200) {
					setLoading(false);
					window.location.reload();
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	}, [selectedFile, profile?.usuario.idUsuario, profile?.token, navigate]);

	useEffect(() => {
		if (profile?.usuario) {
			const nascimento = new Date(profile.usuario.nascimento);
			setValues({
				UsuarioId: profile.usuario.idUsuario,
				nome: profile.usuario.nome ?? "",
				cargo: profile.usuario.cargo ?? "",
				nascimento: nascimento,
				telefone: profile.usuario.telefone,
				email: profile.usuario.email,
			});

			if (profile.profileImage !== undefined) {
				setImageSrc(`data:${profile?.profileImage?.tipo};base64,${profile?.profileImage?.dado}`);
			}
		}
	}, [profile?.usuario]);

	const excluiFoto = async () => {
		if (profile?.profileImage?.arquivoId) {
			await deleteFotoUser(
				profile?.profileImage?.arquivoId,
				profile?.token
			)
				.then((result) => {
					if (result.status === 200) {
						setLoading(false);
						setOpenToastSucesso(true);
						setTextoSucesso("Imagem deletada com sucesso.");
						window.location.reload();
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				});
			setLoading(false);
		} else {
			setSelectedFile(undefined);
			setImageSrc(undefined);
		}
	};

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<NavbarV3 title="Dados Usuário" />
			{!loading && (
				<div className="containerEdita">
					<div className="formAutoEditar">
						<p className="text">
							Edite as informações abaixo para atualizar seus dados!
						</p>
						<Divider direction="horizontal" />
						<Separator size="sm" />
						<div className="container-input">
							<div className="section-input">
								<Separator size="sm" />
								<p>Nome:</p>
								<Separator size="sm" />
								<input
									type="text"
									style={{ width: "350px" }}
									onChange={(e) =>
										setValues((current) => ({
											...current,
											nome: e.target.value,
										}))
									}
									value={values.nome ?? ""}
								/>
								<Separator size="sm" />
								<p>Data Nascimento:</p>
								<Separator size="sm" />
								<input
									type="date"
									style={{ width: "350px" }}
									onChange={(e) =>
										setValues((current) => ({
											...current,
											nascimento: new Date(e.target.value),
										}))
									}
									value={values.nascimento?.toISOString().split("T")[0]}
								/>
							</div>
							<div className="section-input">
								<Separator size="sm" />
								<p>Telefone:</p>
								<Separator size="sm" />
								<input
									type="text"
									style={{ width: "350px" }}
									onChange={(e) =>
										setValues((current) => ({
											...current,
											telefone: e.target.value,
										}))
									}
									value={values.telefone}
								/>
								<Separator size="sm" />
								<p>Email:</p>
								<Separator size="sm" />
								<input
									type="text"
									style={{ width: "350px" }}
									onChange={(e) =>
										setValues((current) => ({
											...current,
											email: e.target.value,
										}))
									}
									value={values.email}
								/>
							</div>
						</div>
						<div className="section-input">
							<Separator size="sm" />
							<p>Cargo:</p>
							<Separator size="sm" />
							<input
								type="text"
								style={{ width: "350px" }}
								onChange={(e) =>
									setValues((current) => ({
										...current,
										cargo: e.target.value,
									}))
								}
								value={values.cargo ?? ""}
							/>
							<Separator size="sm" />
						</div>
						<Separator size="md" />
						<p className="input-label-emb">Foto:</p>
						<input
							id="imageInput"
							type="file"
							accept="image/*"
							onChange={handleImageChange}
							className="image-input"
						/>
						<Separator size="md" />
						{imageSrc && (
							<div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
								<div className="image-preview">
									{imageSrc && <img src={imageSrc} alt="Uploaded preview" />}
								</div>
								<Tooltip title="Excluir">
									<DeleteIcon
										className="trash-v2"
										onClick={() => excluiFoto()}
									></DeleteIcon>
								</Tooltip>
							</div>
						)}

					</div>
					<Box display={"flex"} className="botoes-edit-user">
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							icone="iconeSave"
							titulo="Enviar"
							cor="#0946B8"
							valor={values}
							onClick={() => {
								autoEditaUsuario();
								salvarFoto();
							}}
						/>
						<CustomButtonV2
							classCss="custom-button-cancelar"
							classText="button-texto-cancelar"
							titulo="Cancelar"
							cor="#0946B8"
							valor={values}
							onClick={() => {
								navigate("/");
							}}
						/>
					</Box>
				</div>
			)}
			{loading && <LoadingComponent />}
			<div>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
			</div>
		</motion.div>
	);
}

export default AutoEditar;
